import React from 'react'

const PausedIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clipPath='url(#clip0_8857_38379)'>
        <path
          d='M13.5 3.00024V13.0002C13.5 13.2655 13.3946 13.5198 13.2071 13.7074C13.0196 13.8949 12.7652 14.0002 12.5 14.0002H10C9.73478 14.0002 9.48043 13.8949 9.29289 13.7074C9.10536 13.5198 9 13.2655 9 13.0002V3.00024C9 2.73503 9.10536 2.48067 9.29289 2.29314C9.48043 2.1056 9.73478 2.00024 10 2.00024H12.5C12.7652 2.00024 13.0196 2.1056 13.2071 2.29314C13.3946 2.48067 13.5 2.73503 13.5 3.00024ZM6 2.00024H3.5C3.23478 2.00024 2.98043 2.1056 2.79289 2.29314C2.60536 2.48067 2.5 2.73503 2.5 3.00024V13.0002C2.5 13.2655 2.60536 13.5198 2.79289 13.7074C2.98043 13.8949 3.23478 14.0002 3.5 14.0002H6C6.26522 14.0002 6.51957 13.8949 6.70711 13.7074C6.89464 13.5198 7 13.2655 7 13.0002V3.00024C7 2.73503 6.89464 2.48067 6.70711 2.29314C6.51957 2.1056 6.26522 2.00024 6 2.00024Z'
          fill='#BE8901'
        />
      </g>
      <defs>
        <clipPath id='clip0_8857_38379'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PausedIcon
